<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  CustomerInfo,
  DataRequestItem,
  Pager,
  FundCommissionRate,
  HistoryFilter,
  DataHistoryItem,
  InvoiceFilter,
  DataInvoiceItem,
  BaseIcon,
  InfoArea,
} from "@/components";
import { getBreadCrumbs } from "../utils/breadcrumb";
import mixins from "../mixins";
import ScreenPrices from "../components/base/ScreenPrices.vue";
const ListViewSkeleton = () =>
  import(/* webpackPrefetch: true */ "@/components/base/ListViewSkeleton");

export default {
  name: "CustomerDetail",
  components: {
    CustomerInfo,
    DataRequestItem,
    Pager,
    FundCommissionRate,
    HistoryFilter,
    DataHistoryItem,
    InvoiceFilter,
    DataInvoiceItem,
    BaseIcon,
    InfoArea,
    ScreenPrices,
    ListViewSkeleton,
  },
  mounted() {
    if (this.$route.params.customerId !== undefined) {
      this.cusId = this.$route.params.customerId;
    } else {
      this.cusId = this.veriDagitimModel.userId;
      this.cusNo = this.veriDagitimModel.customerId;
      this.esubeMemberType = this.veriDagitimModel.loginInfo.memberType;
    }
    this.fillFilter();
    this.getAllPackages(this.cusId);
    if (!this.veriDagitimModel) {
      localStorage.setItem("userCusId", this.cusId);
      localStorage.setItem("cusNo", this.getUserInfo?.userName);
      this.setUserCustomerId(this.cusId);
      this.getCustomer();
    } else {
      this.getCustomer();
      this.handleCustomer(this.veriDagitimModel);
      localStorage.setItem("esube", "yes");
      localStorage.setItem("userId", this.cusId);
      localStorage.setItem("cusNo", this.cusNo);
      localStorage.setItem(
        "memberType",
        this.veriDagitimModel.loginInfo.memberType
      );
      if (this.cusId) {
        let userIdAsNumber = parseInt(this.cusId);
        let payload = {
          id: userIdAsNumber,
        };
        this.getMember(payload).then((response) => {
          this.setUserInfo({
            ...response.data,
            memberType: this.esubeMemberType,
          });
        });
      }
    }
  },
  mixins: [mixins],
  props: {
    veriDagitimModel: Object,
    memberType: {
      type: Number,
    },
  },
  data() {
    return {
      recommendedPackages: null,
      getPaymentStatuses: [],
      currentCustomer: null,
      currentYearNumber: new Date().getFullYear(),
      currentMonthNumber: new Date().getMonth() + 1,
      countDown: 10,
      timerRunning: true,
      logsLoader: false,
      timerStatus: "Yenileniyor",
      screenPriceList: [],
      featureScreenPricesList: [],
      newScreenPrice: [],
      tabs: [
        {
          id: 0,
          text: "Veri Paketlerim",
        },
        {
          id: 1,
          text: "Veri Paketi Ekstrelerim",
        },
        {
          id: 3,
          text: "Veri Lisans Ücretleri",
        },
        {
          id: 4,
          text: "Paket Talep Et",
        },
        {
          id: 2,
          text: "Değişiklikler",
        },
      ],
      esube: localStorage.getItem("esube"),
      customerPaymentStatusId: null,
      currentTab: 0,
      cusId: null,
      cusNo: null,
      isDataInvoiceLoaded: true,
      SUCCESSFUL_INTEGRATION: true,
      UNSUCCESSFUL_INTEGRATION: false,
      isMobile: false,
      hideTextWithRule: true,
      esubeMemberType: 3,
    };
  },
  computed: {
    ...mapGetters([
      "apps",
      "profAlgoApps",
      "appsTab",
      "profAlgoTab",
      "fundAndCommissionRates",
      "customer",
      "allPackages",
      "getRecommendedPackages",
      "history",
      "historyList",
      "getFilterList",
      "invoiceList",
      "getHistoryFilter",
      "getUserInfo",
    ]),
    getUserType() {
      const REPRESENTATIVE_CODE = "yes";
      return this.esube === REPRESENTATIVE_CODE;
    },
    customerId() {
      if (this.$route.params.customerNumber) {
        return this.$route.params.customerNumber;
      } else {
        return this.veriDagitimModel.customerId;
      }
    },
    getCustomerPaymentStatusId() {
      if (this.esube == "yes") {
        return this.veriDagitimModel.loginInfo.paymentStatusId;
      } else {
        return this.customer.paymentStatusId;
      }
    },
    getAllPackagesData() {
      return this.allPackages;
    },
    isCompleted() {
      return (
        this.fundAndCommissionRates.fundAmount >=
          this.fundAndCommissionRates.targetFundAmount ||
        this.fundAndCommissionRates.commissionAmount >=
          this.fundAndCommissionRates.targetCommissionAmount
      );
    },
  },
  created() {
    this.isMobile = window.innerWidth < 768;
    if (this.veriDagitimModel) {
      localStorage.setItem("veri-dagitim-token", this.veriDagitimModel.token);
    }
  },
  methods: {
    ...mapActions([
      "handleCustomer",
      "searchCustomer",
      "getAllPackages",
      "getRecommendedPackageList",
      "getHistoryList",
      "getInvoiceList",
      "getFeatureScreenPrices",
      "getApps",
      "getMember",
      "fillFilter",
    ]),
    ...mapMutations([
      "setGeneralFilter",
      "setUserInfo",
      "setUserCustomerId",
      "setInvoiceFilter",
      "setHistoryFilter",
      "setIsPurchaseOrUpgradeHappend",
    ]),
    tabClass(id) {
      return [{ active: this.currentTab === id }, "tab"];
    },
    changeTab(id) {
      const ctrId = this.$route.params.customerId;
      this.currentTab = id;
      this.setGeneralFilter({
        page: 1,
        size: 100,
        filter: {},
      });
      this.timerRunning = false;
      this.countDown = 0;
      if (this.currentTab == 0) {
        this.getAllPackages(ctrId);
        this.timerRunning = true;
        this.countDown = 10;
      } else if (this.currentTab == 1) {
        this.setGeneralFilter({ page: 1, size: 100, filter: {} });
        this.setInvoiceFilter({
          page: 1,
          size: 100,
          filter: {},
        });
        this.getInvoiceList(ctrId);
      } else if (this.currentTab === 2) {
        this.setHistoryFilter({ page: 1, size: 1000, filter: {} });
        this.getHistoryList(ctrId);
      } else if (this.currentTab === 3) {
        this.screenPriceList = [];
        this.getFeatureScreenPrices().then((response) => {
          response.forEach((element) => {
            if (element.applicationName != "Osmanlı Trader") {
              this.screenPriceList.push(element);
            }
          });
        });
      } else if (this.currentTab === 4) {
        this.navigate();
      }
    },
    returnPriceTypeForScreenPrices(priceTypeNumber) {
      if (priceTypeNumber == 1) {
        return "TL";
      } else if (priceTypeNumber == 2) {
        return "USD";
      } else if (priceTypeNumber == 3) {
        return "EUR";
      }
    },
    navigate() {
      const params = {
        customerNumber: this.customerId,
        memberType: this.getUserType,
      };
      const query = {};
      let cusId = this.$route.params.customerId;
      params.customerId =
        cusId !== undefined ? cusId : localStorage.getItem("userId");
      query.c = params.customerId;
      query.m = params.memberType;
      this.$router.push({
        name: "BuyDataPackage",
        params,
        query,
      });
    },
    getRecommendedData() {
      this.getRecommendedPackageList(this.cusId).then((res) => {
        if (res) {
          this.recommendedPackages = this.getRecommendedPackages;
        }
      });
    },
    checkIsDataInvoiceFilterChangedAndLoaded(param) {
      this.isDataInvoiceLoaded = param;
    },
    getCustomer() {
      this.searchCustomer({
        customerNo: this.customerId,
        cusId: this.cusId,
      }).then((res) => {
        if (!res.statusCode) {
          getBreadCrumbs({
            breadcrumbs: ["CustomerDetail"],
            customer: this.customer,
            customerDetail: this.customerId,
            cusId: this.cusId,
          });

          const paymentStatuses = this.getFilterList.filter((o) => {
            return o.name === "PaymentStatus";
          });

          if (paymentStatuses.length > 0)
            this.getPaymentStatuses = paymentStatuses[0].values;
          this.currentCustomer = this.customer;
        }
      });
    },
    toggleCountdown() {
      this.timerRunning = !this.timerRunning;
      if (!this.timerRunning) {
        this.timerStatus = "Duraklatıldı";
      } else {
        this.timerStatus = "Yenileniyor.";
        this.countDown = 10;
      }
    },
    timerChecker(isPopupOpened) {
      if (isPopupOpened) {
        this.timerRunning = false;
      } else {
        this.timerRunning = true;
        this.countDown = 10;
      }
    },
    subtitleRules(d) {
      let result = null;
      if (
        d.application != null &&
        (d.application.id == 3 || d.application.id == 2)
      ) {
        result = d.application.shortContent;
      } else if (d.research.length && d.application == null) {
        result = d.research[0].name;
      } else if (
        d.algorithm.length &&
        d.platform == null &&
        (d.application.id == 4 || d.application.id == 7)
      ) {
        result = d.algorithm[0].name;
      } else {
        result = d.platform.name;
      }

      return result;
    },
    subtitleRulesInvoice(d) {
      let result = null;
      if (
        d.application != null &&
        (d.application.applicationId == 3 || d.application.applicationId == 2)
      ) {
        result = d.application.shortContent;
      } else if (d.research.length && d.application == null) {
        result = d.research[0].name;
      } else if (
        (!d.algorithm.length || d.algorithm.length) &&
        (d.application.applicationId == 7 ||
          d.application.applicationId == 4) &&
        d.platform?.platformId == 1
      ) {
        result = d.platform.name;
      } else if (
        d.algorithm.length &&
        d.application.applicationId == 4 &&
        d.platform?.platformId != 2
      ) {
        result = d.algorithm[0].name;
      } else if (
        d.algorithm.length &&
        d.application.applicationId == 7 &&
        d.platform == null
      ) {
        result = d.algorithm[0].name;
      } else {
        result = d.platform.name;
      }
      return result;
    },
    checkMonthRule(selectedMonth) {
      let currentMonth = new Date().getMonth() + 1;
      if (currentMonth == selectedMonth || selectedMonth == -1) {
        this.hideTextWithRule = true;
      } else {
        this.hideTextWithRule = false;
      }
    },
  },
  watch: {
    countDown: {
      handler(value) {
        if (this.currentTab == 0 && value >= -1) {
          if (this.timerRunning) {
            setTimeout(() => {
              this.countDown--;
              if (this.countDown === 0) {
                this.logsLoader = true;
                this.getAllPackages(this.$route.params.customerId);
                this.getRecommendedData();
              } else if (this.countDown === -1) {
                this.logsLoader = false;
                this.countDown = 10;
              }
            }, 1000);
          }
        }
      },
      immediate: true,
      deep: true,
    },
    getAllPackagesData: {
      handler(value) {
        const allData = JSON.parse(JSON.stringify(value.data));

        const checkIsRequested = allData.filter(
          (o) =>
            o.packageStatus.id === this.Products.status.requestedPackageID &&
            o.isSuccessfulIntegration === this.SUCCESSFUL_INTEGRATION
        );

        const checkisSuccessfulIntegration = allData.filter(
          (o) =>
            o.packageStatus.id === this.Products.status.requestedPackageID &&
            o.isSuccessfulIntegration === this.UNSUCCESSFUL_INTEGRATION
        );

        this.timerRunning =
          (checkIsRequested.length > 0 ? true : false) ||
          (checkIsRequested.length === checkisSuccessfulIntegration.length
            ? false
            : true);

        if (checkIsRequested || checkisSuccessfulIntegration) {
          this.setIsPurchaseOrUpgradeHappend(false);
        } else {
          this.setIsPurchaseOrUpgradeHappend(true);
        }
      },
      deep: true,
    },
  },
};
</script>
<template>
  <div class="customer-detail">
    <customer-info
      :customerNumber="customerId"
      :currentCustomer="customer"
      :getPaymentStatuses="getPaymentStatuses"
    />
    <div class="tab-layout">
      <div class="tabs custom-container">
        <div
          @click="changeTab(tab.id)"
          :key="tab.id"
          v-for="tab in tabs"
          :class="tabClass(tab.id)"
          :id="'tab-' + tab.id"
        >
          <h6>{{ tab.text }}</h6>
        </div>
      </div>

      <div class="tab-content">
        <div v-if="currentTab === 0" class="data-types">
          <div v-if="cusId">
            <fund-commission-rate
              :customerId="parseInt(cusId, 0)"
            ></fund-commission-rate>
          </div>

          <div id="dataRequest" class="data-requests custom-container">
            <div class="data-requests-timer">
              <div class="info-row">
                <info-area
                  :infoText="'Lisans iptallerinin, içerisinde bulunulan ayın son gününe kadar gerçekleştirilmesi gerekmektedir. Tanımlı veri paketinizin iptal edilmemesi durumunda, mevcut paketiniz her ay başında tekrar güncellenecektir.'"
                  :typeWarning="true"
                ></info-area>
              </div>
              <div v-if="timerRunning" class="timer-status">
                <span>{{ countDown }} saniye içerisinde güncellenecektir.</span>
              </div>
            </div>
            <list-view-skeleton v-if="logsLoader" :line-count="10" />
            <data-request-item
              v-else
              :key="d.id"
              v-for="d in allPackages.data"
              :dataItem="{
                title:
                  d.research.length && d.application == null
                    ? d.research[0].name
                    : d.application.name,
                subtitle: subtitleRules(d),
                imageUrl: d.imageUrl,
                ...d,
              }"
              @checkIsPopupOpen="timerChecker($event)"
            ></data-request-item>
            <Pager
              :pageName="'dataRequest'"
              :page="allPackages.page"
              v-if="allPackages.page"
            />
          </div>
        </div>
        <div id="invoice" v-if="currentTab === 1" class="invoice-area">
          <div class="top-area custom-container">
            <InvoiceFilter
              :currentYearNumber="String(this.currentYearNumber)"
              :currentMonthNumber="String(this.currentMonthNumber)"
              @filterChangeResponse="checkIsDataInvoiceFilterChangedAndLoaded"
              @monthChanged="checkMonthRule"
            />
          </div>
          <div class="table-area custom-container">
            <div class="warning-area" v-if="esube == 'no' && hideTextWithRule">
              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 0 &&
                  !isCompleted &&
                  invoiceList.data.length > 0
                "
              >
                <info-area
                  :infoText="'Komisyon ya da BES/FON şartı sağlanmadığı için ekran ücreti tahsil edilecektir.'"
                  :typeWarning="true"
                ></info-area>
              </div>
              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 0 &&
                  isCompleted &&
                  invoiceList.data.length > 0
                "
              >
                <info-area
                  :infoText="'Komisyon ya da BES/FON şartı sağlandığı için ekran ücreti tahsil edilmeyecektir.'"
                  :typeWarning="true"
                ></info-area>
              </div>
            </div>

            <div class="warning-area" v-else>
              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 2 &&
                  isCompleted &&
                  invoiceList.data.length > 0 &&
                  hideTextWithRule
                "
              >
                <info-area
                  :infoText="'Masraf ödeme durumu “Her zaman temsilci” olması sebepli ekran ücreti temsilcinize yansıtılmıştır.'"
                  :typeWarning="true"
                ></info-area>
              </div>

              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 0 &&
                  !isCompleted &&
                  invoiceList.data.length > 0 &&
                  hideTextWithRule
                "
              >
                <info-area
                  :infoText="'Komisyon ya da BES/FON şartı sağlanmadığı için ekran ücreti tahsil edilecektir.'"
                  :typeWarning="true"
                ></info-area>
              </div>

              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 1 &&
                  isCompleted &&
                  invoiceList.data.length > 0 &&
                  hideTextWithRule
                "
              >
                <info-area
                  :infoText="'Masraf Ödeme Durumunuz “Her zaman müşteri” olması sebepli ekran ücreti tarafınıza yansıtılmıştır.'"
                  :typeWarning="true"
                ></info-area>
              </div>

              <div
                class="warning-texts"
                v-if="
                  getCustomerPaymentStatusId == 0 &&
                  isCompleted &&
                  invoiceList.data.length > 0 &&
                  hideTextWithRule
                "
              >
                <info-area
                  :infoText="'Komisyon ya da BES/FON şartı sağlandığı için ekran ücreti tahsil edilmeyecektir.'"
                  :typeWarning="true"
                ></info-area>
              </div>
            </div>

            <base-icon
              class="loader-icon"
              name="loader"
              v-if="!isDataInvoiceLoaded"
            ></base-icon>
            <data-invoice-item
              v-else
              :key="d.id"
              v-for="d in invoiceList.data"
              :dataItem="{
                title:
                  d.productName != null ? d.productName : d.research[0].name,
                subtitle: subtitleRulesInvoice(d),
                imageUrl: d.imageUrl,
                ...d,
              }"
            />
            <Pager
              :pageName="'invoice'"
              :page="invoiceList.page"
              v-if="invoiceList.page"
            />
          </div>
        </div>

        <div
          id="history"
          v-if="currentTab === 2"
          class="history-area custom-container"
        >
          <div class="top-area">
            <h3>Değişiklikler</h3>
            <history-filter />
          </div>
          <div class="history-table-container">
            <div class="history-table">
              <div class="table-area">
                <div class="main-title-area">
                  <div class="left">
                    <span class="title">İşlem Tarihi</span>
                  </div>
                  <div class="right">
                    <span class="title">Değişiklik Bilgileri</span>
                  </div>
                </div>
                <data-history-item
                  :key="d.id"
                  v-for="d in historyList.data"
                  :dataItem="d"
                ></data-history-item>
              </div>
            </div>
          </div>
        </div>
        <div
          id="screen-prices"
          v-if="currentTab === 3"
          class="screen-prices custom-container"
        >
          <screen-prices
            :screenPriceList="screenPriceList"
            :featureScreenPricesList="featureScreenPricesList"
            :isMobile="isMobile"
          ></screen-prices>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.customer-detail {
  padding: 0px 20px;

  @media (max-width: 768px) {
    padding: 0px 16px;
  }

  .screen-prices {
    padding: 20px;
    background: var(--grayscale-0);
    @media (max-width: 768px) {
      overflow: auto;
    }
  }

  ::v-deep .form-control-label,
  ::v-deep .data-types .fund-commission.comission-container {
    font-weight: bold;
  }

  .data-requests {
    position: relative;
    margin-top: 20px;
    padding: 20px;
    background: var(--grayscale-0);
    &__title-wrapper {
      display: flex;
      flex-wrap: wrap;
      justify-content: flex-end;
      align-items: flex-end;
      margin-bottom: 20px;
    }
    .data-requests-timer {
      margin-bottom: 20px;
      position: relative;
      .info-row .infoArea {
        position: relative;
        justify-content: left;
        text-align: left;
        padding: 12px;

        @media (max-width: 768px) {
          align-items: flex-start;
        }
      }
      .timer-status {
        font-size: 12px;
        margin-top: 20px;
        font-weight: bold;
        color: var(--grayscale-180);
        position: relative;
      }
      .base-button {
        max-width: 300px;
      }
      .loader-icon {
        right: auto;
        left: 0px;
      }
    }
    @media (max-width: 768px) {
      padding: 20px 12px;
    }
  }

  .tab-layout {
    .tabs {
      position: relative;
      display: flex;
      justify-content: flex-start !important;
      align-items: center;
      padding-bottom: 0;
      padding-top: 0;
      background: var(--grayscale-0);
      margin-top: 20px;
      border-bottom: 1px solid var(--color-primary-tint-second);
      height: 56px;
      top: 1px;

      @media (max-width: 768px) {
        height: auto;
        gap: 20px;
        padding: 0px;
        overflow-x: scroll;
        padding-left: 12px;
        box-sizing: border-box;
        &::-webkit-scrollbar {
          width: 0px;
          height: 0px;
        }
      }

      h6 {
        font-weight: 400;
        color: var(--color-primary-silver-metallic);
      }

      .tab {
        cursor: pointer;
        flex: 0.33;
        height: 56px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 2px solid transparent;
        max-width: 200px;
        width: 100%;
        @media (max-width: 768px) {
          max-width: auto;
          width: auto;
          flex: 0 0 auto;
          &:last-child {
            padding-right: 10px;
          }
        }
      }

      .active {
        border-bottom: 3px solid var(--color-primary-green);

        h6 {
          font-weight: bold;
          color: var(--color-primary-green);
        }
      }
    }
  }

  .history-area {
    padding: 40px;
    background-color: var(--grayscale-0);

    .top-area {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
    }

    .table-area {
      border: 1px solid var(--grayscale-20);
      border-radius: var(--radius-second);
      font-size: 12px !important;

      .left {
        width: 140px;
        padding: 10px;
        text-align: center;
      }

      .right {
        padding: 30px;
        width: 100%;
      }

      .main-title-area {
        display: flex;
        align-items: center;
        font-weight: bold;
        font-size: 12px;
      }
    }
  }

  .invoice-area {
    .warning-texts {
      position: relative;
      .infoArea {
        position: relative;
        padding: 12px;
        align-items: center;
        @media (max-width: 768px) {
          align-items: flex-start;
        }
      }
    }

    .top-area {
      background: var(--grayscale-0);
      margin-bottom: 20px;
      .filter {
        justify-content: flex-start;
        padding: 20px 0px;
      }
    }
    .table-area {
      position: relative;
      padding: 0px;
      background: var(--grayscale-0);
      padding-bottom: 20px;

      .warning-area {
        padding-top: 20px;
        padding-left: 20px;
        padding-right: 20px;

        @media (max-width: 768px) {
          padding-left: 12px;
          padding-right: 12px;
        }
      }

      .loader-icon {
        right: auto;
      }
    }
  }

  .history-table-container {
    width: 100%;
    overflow-y: auto;
    .history-table {
      width: 100%;
      min-width: 520px;
    }
  }
}
</style>
